import React from 'react';
import { Link, Outlet } from 'react-router-dom';

const JuevesComadres = () => {
  return (
    <div className="container">
      <nav>
     
      </nav>
      <Outlet />
    </div>
  );
}

export default JuevesComadres;
